import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=52612b17&scoped=true"
import script from "./product-card.vue?vue&type=script&lang=js"
export * from "./product-card.vue?vue&type=script&lang=js"
import style0 from "./product-card.vue?vue&type=style&index=0&id=52612b17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52612b17",
  null
  
)

/* custom blocks */
import block0 from "./product-card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports